/** Engajamento: curtidas, visualizações e audiência — tipos do contrato. */
import type { components } from '@/core/http';

export type Engagement = components['schemas']['EngagementOut'];
export type LikedLesson = components['schemas']['LikedLessonOut'];
export type Audience = components['schemas']['AudienceOut'];
export type Viewer = components['schemas']['ViewerOut'];

/** Curtida otimista: aplica antes da resposta, a API confirma depois. */
export function toggledLike(e: Engagement): Engagement {
  return { ...e, liked_by_me: !e.liked_by_me, likes: Math.max(0, e.likes + (e.liked_by_me ? -1 : 1)) };
}

const compact = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 });

/** "1 visualização", "1,2 mil visualizações". */
export function countLabel(n: number, singular: string, plural: string): string {
  return `${compact.format(n)} ${n === 1 ? singular : plural}`;
}

export const DEVICE_LABELS: Record<string, string> = {
  desktop: 'Computador',
  mobile: 'Celular',
  tablet: 'Tablet',
  tv: 'TV',
  desconhecido: 'Desconhecido',
};

/** "12 min", "1 h 05 min", "45 s" — tempo assistido. */
export function watchedLabel(seconds: number): string {
  const s = Math.round(seconds);
  if (s < 60) return `${s} s`;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return h ? `${h} h ${String(m).padStart(2, '0')} min` : `${m} min`;
}
